import { AbstractFormFragment } from '@components/form/AbstractFormFragment';

export class CheckBoxGroupFormFragment extends AbstractFormFragment {
  static getCssClassName(): string {
    return 'comp-form-checkbox';
  }

  initializeNode(): this {
    this.blurOnMouseRealMouseClick();
    return this;
  }

  hasValue(): boolean {
    return !!this.node.querySelector(':checked');
  }

  getLabel(): string {
    return this.node.querySelector('div.label')?.textContent?.trim() ?? '';
  }

  getErrorIndicatorNode(): HTMLElement | null {
    return this.node.querySelector('label');
  }

  attachChangeListener(callback: () => void): this {
    this.node.querySelectorAll<HTMLInputElement>('input[type=checkbox]').forEach((input) => {
      input.addEventListener('change', () => callback());
    });
    return this;
  }
}

export default CheckBoxGroupFormFragment;
